import React from "react";
import { useSelector } from "react-redux";
import styles from "../../schoolCockpit/master/academicConfiguration/Academiclist.module.css";
import { formatCurrency } from "./payFeesColumns";

function PayFeesHistoryPanel({ row }) {
  const { translations } = useSelector((state) => state.language);
  const history = row?.original?.payment_history || [];

  if (!history.length) {
    return (
      <div className={styles.accordionEmpty}>
        {translations?.labels?.noPaymentHistory || "No payment history found"}
      </div>
    );
  }

  return (
    <div className={styles.accordionPanel}>
      <table className={styles.accordionTable}>
        <thead>
          <tr>
            <th>{translations?.labels?.date || "Date"}</th>
            <th>{translations?.labels?.paymentMode || "Payment Mode"}</th>
            <th>
              {translations?.labels?.upiTransactionId || "UPI Transaction ID"}
            </th>
            <th>{translations?.labels?.paid || "Paid"}</th>
            <th>{translations?.labels?.balance || "Balance"}</th>
          </tr>
        </thead>
        <tbody>
          {history.map((h, idx) => (
            <tr key={idx}>
              <td>{h.date || "-"}</td>
              <td>{h.payment_mode || "-"}</td>
              <td>{h.upi_transaction_id || "-"}</td>
              <td>{formatCurrency(h.paid)}</td>
              <td>{formatCurrency(h.balance)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default PayFeesHistoryPanel;
